<template >
    <div>


      <template>

        <v-snackbar
      v-model="mensaje.snackbar"
      :timeout="mensaje.timeout"
      :color="mensaje.color"
      text
      top
      right
    >
      {{ mensaje.text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          :color="mensaje.colorBtn"
          text
          v-bind="attrs"
          @click="mensaje.snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>

      </template>

      

        
<v-container>


 
      <v-row  >

        <v-col cols="2">

        </v-col>

        
        <v-col cols="8">


             <v-card  elevation="6">
          <v-card-title class="text-h5">
            Pantalla de Registro de Usuario
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-text-field
                      v-model="usuario.name"
                      label="Usuario Nombre"
                      :rules="textRules"
                      required
                      data-cy="name-input"
                    ></v-text-field>

                     <v-text-field
           v-model="usuario.identificador"
           label="Identificador para su página"
           :counter="3"
           :rules="textRules"
           required
         ></v-text-field>

                        <v-text-field
           v-model="usuario.email"
           label="Correo"
           :counter="3"
           :rules="emailRules"
           required
         ></v-text-field>
   

                    <v-text-field
                      v-model="usuario.password"
                      :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                      :rules="[rules.required, rules.min]"
                      :type="showPass ? 'text' : 'password'"
                      name="input-pass"
                      label="Contraseña"
                      hint="Minimo 5 caracteres"
                      counter
                      @click:append="showPass = !showPass"
                      data-cy="pass-input"
                    ></v-text-field>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>


            <v-row >
         <v-col cols="12" sm="12" lg="6" class="d-flex justify-end">


            <v-spacer></v-spacer>
            <v-btn  outlined color="red darken-1"  text  @click="limpiar">
               <v-icon>
       mdi-cancel
      </v-icon> 
              Cancelar
            </v-btn>
            <v-btn outlined text color="blue darken-4" 
            @click="registrar"
            data-cy="submit"
            >

            <v-icon>
       mdi-content-save-outline
      </v-icon> 
              Registrar
            </v-btn>


         </v-col>


         <v-col cols="12" sm="12" lg="6" class="d-flex justify-end">


            <v-btn class="mr-2" outlined color="blue darken-4" 
            text
             @click="loginWithGoogle"
            data-cy="submit"
            >
            <img src="@/assets/img/svg/google-icon.svg" alt="Google Icon" width="20" height="20" class="mr-1">
          
              LOGIN WITH GOOGLE
      
            </v-btn> 

         </v-col>

            </v-row>
       
          </v-card-actions>
        </v-card>


        </v-col>


      </v-row>


      

</v-container>



    </div>



</template>




<script>
import usuarioService from "@/services/usuarioService.js";

import axios from 'axios'

import UsuarioDialog from '../usuario/UsuarioDialog';



import router from "@/router/index";

export default {
     name: 'UsuarioRegister',
    
  components: {
   UsuarioDialog
  },
  computed: {
    tab: {
      set (tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } })
      },
      get () {
        return this.$route.query.tab
      }
    }
  },
    data: vm => ({
      mensaje:{
          snackbar: false,
          text: '',
          color:'',
          timeout: -1,
      },
    valid: true,
    tab:"",
    buscador:'',
showPass: false,
  usuarios: [],
        usuario:{
id:'',
name:'',
email:'',
identificador:'',
password:''
        },

        rules: {
                  required: value => !!value || 'Campo Requerido',
                  min: v => v.length >= 5 || 'Minimo 5 caracteres',
                  emailMatch: () => (`The email and password you entered don't match`),
                },
        	messages:undefined,
         textRules: [
              (v) => !!v || "Campo es requerido",
              (v) => (v && v.length >= 3) || "Debe contener al menos 3 caracteres",
            ],
            emailRules:  [
              (v) => !!v || "Correo es requerido",
              (v) => /.+@.+\..+/.test(v) || "Correo debe ser valido",
            ]
        
    
  }),
  created(){

       }
  ,mounted(){
    

   
    },

  methods: {

            loginWithGoogle() {

             

                const url = this.$router.resolve({ path: '/api/login/google' }).href;
              window.location.href = url;


            },

    async recaptcha() {
  try {
    // Espera hasta que reCAPTCHA esté listo
    await this.$recaptchaLoaded();

    // Ejecuta la verificación con la acción "login"
    const token = await this.$recaptcha('login');

    // Asigna el token
   // this.usuario.recaptcha = token;
  //  this.tokenRe = token; // Asigna el valor a this.tokenRe si lo necesitas

    // Retorna el token para su uso posterior
    return token;
  } catch (error) {
    console.error('Error al ejecutar reCAPTCHA:', error);
    throw error; // Lanza el error para manejarlo externamente
  }
},


   async registrar(){


    try {
      const token = await this.recaptcha(); // Espera hasta que recaptcha() termine


     // console.log('Token obtenido:', token);
      this.usuario.recaptcha=token;


    } catch (error) {
    console.error('Error en reCAPTCHA:', error);
  }


    if (this.$refs.form.validate()) {
   
        console.log(this.usuario);

                  //Enviar a store/index en vuex el valor de usuario
                  //quitar la seña antes
        

          usuarioService.save(this.usuario).then(response=>{
         
              alert('Usuario registrado exitosamente!!,\n en breve recibira un correo para verificar su cuenta')

              console.log(response.data.data.token);
          this.token = response.data.data.token;
          localStorage.setItem("token", this.token);

            //codigo agregado para nuevos usuarios.
          this.$store.commit('setIdentificador', response.data.data.identificador);
          this.$store.commit('setLinkPhoto', response.data.data.linkPhoto || '');
          this.$store.commit('setLogueado', true);
          router.push("perfil/"+response.data.data.identificador+"/add"); 




  this.limpiar();

          }).catch(e=>{

//this.errors =e.response.data.errors

//console.log(e.response.data);


//console.log(e.response.data);

console.log(e.response.message);

let mensajeError = '';


console.log(e.response.data.message);
if (e.response && e.response.data) {
      const errors = e.response.data; // Accede a 'data' en la respuesta
      if (errors) {
      //  console.log(errors.email[0]); // "The email has already been taken."



        mensajeError += "\n"+""+errors.message;

        
      }else{
        console.log(errors.message);
      }

    }



    //alert('Mensaje: '+mensajeError);

  this.mensaje.text=mensajeError;

this.mensaje.snackbar="true";

this.mensaje.color="error";
this.mensaje.colorBtn="error";

});


        
      }
    },
    limpiar(){

     
		this.usuario={
				id:'',
				name:'',
        email:'',
        identificador:'',
        ci:'',
				password:''
	}

        
    },
  recibirUsuario:function(usuario){

      console.log('En elemento padre Redact despues de editar');
        console.log(usuario);
 
    },
		
    validate () {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
    //  this.$refs.form.reset();
      this.limpiar();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    recibirUsuarioOpcion:function(usuarioOpcion){

      console.log('En elemento padre Usuario');
        console.log(usuarioOpcion);
     

    }
  },

    watch: {
      date (val) {
        
		
       
      },
    },
  computed:{   
  
  },
};
</script>